import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/file`;

export const getById = (id: string) => {
  const headers = authHeader();

  return axios.get(API_URL + "/" + id, {
    responseType: 'arraybuffer',
    headers: {
      Authorization: headers.Authorization,
      Accept: 'application/octet-stream',
    },
  });
};